import { Injectable } from "@angular/core";
import { CustomerActions } from "../actions/customer-actions";
import { CustomerService } from "../services/customer-service";

@Injectable()
export class CustomerEpics {

    constructor(private customerService: CustomerService) {
    }

    getCustomerEpic = (action$) => {
        return action$.ofType(CustomerActions.GET_CUSTOMER)
            .switchMap((action) => {
                return this.customerService.getCustomer(action.payload)
            })
            .map((response) => {
                return {type: CustomerActions.GET_CUSTOMER_SUCCESS, payload: response};
            })
    };

    getCustomerSiblingsEpic = (action$) => {
        return action$.ofType(CustomerActions.GET_CUSTOMER_SIBLINGS)
            .switchMap((action) => {
                return this.customerService.getCustomerSiblings(action.payload)
            })
            .map((response) => {
                return {type: CustomerActions.GET_CUSTOMER_SIBLINGS_SUCCESS, payload: response};
            })
    };
};
